<template>
  <div>
    <div v-if="allowDisplayMatrice" style="display: flex; justify-content: center;">
      <div id="svgMatrix">
        <div v-for="(row, rowIndex) in renderMatriceCombinated" :key="'row_' + rowIndex" class="row-svg" style="display: flex;">
          <div v-for="(col, colIndex) in row.rowArray" :key="'row_' + rowIndex + '_col_' + colIndex" class="cell-svg">
            <CMeasureMatrice3 
              :col="col" 
              :size="renderSquareSize"
              :layerColors="layerColors"
              :rowIndex="rowIndex"
              :colIndex="colIndex"
              :midCol="renderMidCol"
              :maxRow="renderMatriceCombinated ? renderMatriceCombinated.length : 0"
              :isMlp="(rowIndex === (mlpRow + 1) && colIndex === (mlpCol + 1)) ? true : false"
              :doExport="doExport"
              :algoSelected="algoSelected"
              @MatriceClicked="handleMatriceClicked"
              @ContextualHelpChanged="emitContextualHelpChanged"
            ></CMeasureMatrice3>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!allowDisplayMatrice" id="error_help" class="help-zone mt-2">
      <div class="help-title text-left ml-2 text-warning">
        <img src="@/lib/tui/assets/warning/warning.svg" class="mr-2"/>
        {{ $t('notPossibleTitle') }}
      </div>
      <div class="tip-help text-left ml-2 mt-2">
        {{ $t('notPossibleDescription') }}
      </div>
    </div>
  
    <div v-if="contextualHelp" id="measure_help" class="help-zone mt-2">
      <div class="help-title text-left ml-2" :class="contextualHelp === 'boundary' ? 'text-warning ': null">{{ renderContextualHelpTitle }}</div>
      <div class="tip-help text-left ml-2">
        {{ renderContextualHelp }}
      </div>
    </div>


  </div>
</template>

<script>
import _ from "lodash";
import CMeasureMatrice3 from "@/components/measures/CMeasureMatrice3.vue";
export default {
  name: "CMainMeasures",
  ///////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////
  components: {
    CMeasureMatrice3
  },
  ///////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////
  props: {
    seats: Array,
    algoSelected: String,
    algoList: Array,
    layerColors: Array,
    layerSelected: Number,
    maxNbPoints: Number,
    contextualHelp: String,
    doExport: Boolean
  },
  ///////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////
  data () {
    return {
      matriceMaxWidth: 90,
      matriceMaxHeight: 65,
      userPoints: [],
      autoPoints: [],
      room: [],
      nbRows: 0,
      nbCols: 0,
      maxSeats: 0, // max seats per row (nb of seats in largest row)
      combinatedPoints: [],
      mlpUser: false,
      mlpCol: -1,
      mlpRow: -1,
      nbPoints: 0,
      startRow: -1,
      skipFactor: 1,
      isIncreasedNbCols: false,
      isReducedNbRows: false,
      allowDisplayMatrice: true
    }
  },
  ///////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////
  mounted: function() {
    this.renderMatrice();
  },
  ///////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////
  methods: {    
    emitContextualHelpChanged: function(event) {
      this.$emit("ContextualHelpChanged", event);
    },
    ///////////////////////////////////////////////////////////////
    renderMeasureID: function(row, col, nbCols) {
      let id = 0;

      id += (row * nbCols) + col;

      return id;
    },
    /////////////////////////////////////////////////////////////
    handleMatriceClicked: function(event) {
      if (this.autoPoints.length < event.row) {
        console.warn("clicked is not in the matrice");
        return;
      }

      if (this.autoPoints[event.row].length < event.col) {
        console.warn("clicked is not in the matrice");
        return;
      }

      let found = this.userPoints.find(s => s.id === event.id);

      if (this.layerSelected === -2) {
        this.mlpUser = true;
        this.mlpRow = event.row;
        this.mlpCol = event.col;
        return;
      }

      if (!found) {
        this.userPoints.push({ ...event, layer: this.layerSelected });
      }
      else {
        if (found.layer !== this.layerSelected) {
          found.layer = this.layerSelected;
        }
        else {
          found.layer = -1;
        }
      }

      if (this.algoSelected !== "custom")
        this.$emit("CustomLayer", "custom");
    },
    //////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////
    renderMatrice: function() {
      // Render an array of objects. An object may contain
        // a seat
        // a measurement point in a specific layer
        // a measurement boubdary label
        // a measurement label (numérotage)
      //
      if (!this.seats || this.seats.length === 0) return;
      if (!this.maxNbPoints) return;
      
      this.setMatrixSize(); // array size according to nb of rows of seats and nb of seats per row 
      
      this.skipFactor = 1; // to increase if nb of measurements exceeds the max (density of the grid)

      this.adjustNbCols(); // add lateral columns when they are not needed
  
      this.initMatrice(); // empty array 

      this.setSeats(); // assign the seats to their positions

      this.setMeasurements(); // assign the measurements (label 0, 1, ...) to their positions

      this.nbPoints = this.calculateNbPoints(this.autoPoints);
      
      if (this.nbPoints > this.maxNbPoints) {
        this.reduceNbPoints();
      }

      if (this.counter === 10) return;
      this.setMeasurementBoundaries(); // pour l'affichage des limites de la zone de mesures
      this.room = this.addRoomBoundaries(this.autoPoints); // pour l'affichage des mur de la salle
      this.labelMeasures(); // pour le numérotage des points de mesures
      return;
    },
    ////////////////////////////////////////////////////////////////
    setMatrixSize: function() {
      // array size according to nb of rows of seats and nb of seats per row
      this.nbRows = Math.max(4, 2 * this.seats.length); // nbRows of the array according to the nb of rows of seats
                                                        // minumum 4 to avoid small grids for rooms with one row of seats
      
      this.maxSeats = Math.max(...this.seats); // nb seats in the largest row of seats
      this.nbCols = 2 * this.maxSeats - 1; // nbCols in the array according to maxSeats
      
      this.isIncreasedNbCols = false;
      this.isReducedNbRows = false;
      /////// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!1
      return;
    },
    //////////////////////////////////////////////////////////////
    adjustNbCols: function() {
      // according to the numbers of seats per row, 2 or 4 extra columns are needed on the sides
      if (this.maxSeats <= 2) {
        this.nbCols = 5;
        return;
      }

      switch (this.algoSelected) {
        case "algo1": {
          if (
            (
              (this.seats[0] - this.seats[1]) % 2 === 0 // row1 and row1 have the same parity
              && (this.maxSeats - this.seats[0]) % 2 === 0 // max nb of seats per row has the same parity as row1 (and row2)
            ) // guarantee that measurements are on the seats of the first two rows (try 2-2-3 and 3-3-4)
            || (
              (this.seats[0] - this.seats[1]) % 2 !== 0 // row1 and row2 have different parities
              && (this.maxSeats % 2 === 1) // max nb of seats is odd
            ) // guarantee that the measurements are on the seats of the odd row of seats
            // || isTooBig // see definition
          ) {
            return;
          }
          else {
            this.insertSideCols();
            return;
          }
        }
        case "algo2": {
          if (
              (
                (this.seats[0] - this.seats[1]) % 2 === 0 // row1 and row1 have the same parity
                &&
                this.seats.length >= 3 // there are at least 3 rows of seats
                &&
                (
                  (this.seats[2] - this.seats[0]) % 2 === 0 // row3 has same parity as row1 (and row2)
                  ||
                  (
                    (this.seats[2] - this.seats[0]) % 2 != 0 // row3 has different parity than row1 (and row2)
                    &&
                    (this.maxSeats - this.seats[0]) % 2 != 0 // the max nb of seats per row has different parity than row1 (and row2)
                  )
                ) 
              ) // maximize the number of seats with measurements among the first 3 rows
              ||
              (
                (this.seats[0] - this.seats[1]) % 2 !== 0 // row1 and row2 have different parities
                &&
                (this.maxSeats - this.seats[0]) % 2 === 0 // max nb of seats per row has the same parity as row1
              ) // guarantee the measurements are on the seats of the first two rows
              // || isTooBig // see definition
          ) {
            return;
          }
          else {
            this.insertSideCols();
            return;
          }
        }
      }
      return;
    },
    ///////////////////////////////////////////////////////////////
    insertSideCols: function() {
      this.nbCols += 2;
      this.increasedNbCols = true;
    },
    ///////////////////////////////////////////////////////////////
    removeSideCols: function() {
      this.nbCols -= 2;
      this.increasedNbCols = false;
    },
        ///////////////////////////////////////////////////////////////
    deleteFirstRow: function() {
      this.autoPoints.shift(); // delete first row from matrix while keeping the rest with the same measures
      this.nbRows -= 1;
      this.isReducedNbRows = true;
    },
    ///////////////////////////////////////////////////////////////
    initMatrice: function() {
      let autoPoints = [];
      for (let i = 0; i < this.nbRows; i++) {
        let rowArray = [];
        for (let j = 0 ; j < this.nbCols; j++) {
          let tmpLayer = -1;
          rowArray.push({ 
            id: this.renderMeasureID(i, j, this.nbCols),
            row: i,
            col: j,
            layer: tmpLayer, 
            seat: false,
            measurementBoundary: [],
            roomBoundary: []
          });
        }
        autoPoints.push({
          rowArray: rowArray,
          containSeats: false,
          listeningStart: -1,
          listeningEnd: -1
        });
      }
      this.autoPoints = autoPoints;
    },
    ///////////////////////////////////////////////////////////////
    setSeats: function() {
      if (this.seats.length === 1) this.startRow = 2;
      else this.startRow = 1;
      //
      this.seats.forEach((nbSeatsInRow, seatRowIndex) => { // seatRowIndex est l'indexe du rang de sièges
        let totalSpacesForSeats = nbSeatsInRow * 2 - 1;
        let startCol = Math.floor((this.nbCols - totalSpacesForSeats) / 2);
        let rowIndex = this.startRow + seatRowIndex * 2;
        this.autoPoints[rowIndex].listeningStart = startCol;
        this.autoPoints[rowIndex].listeningEnd = startCol + totalSpacesForSeats - 1;
        this.autoPoints[rowIndex].containSeats = true;

        for (let j = 0; j < totalSpacesForSeats; j += 2) { 
          if (rowIndex < this.nbRows && (startCol + j) < this.nbCols) {
            this.autoPoints[rowIndex].rowArray[startCol + j].seat = true;
          }
        }
      });
    },
    ///////////////////////////////////////////////////////////////
    setMeasurements: function() {
      const incrementFactor = this.skipFactor + 1;
      // 
      switch (this.algoSelected) {
        case "algo1": {
          // Layer 1
          for (let i = 1; i < this.nbRows; i += 2) {
            for (let j = 0; j < this.nbCols; j += incrementFactor) {
              this.autoPoints[i].rowArray[j].layer = 0;
            }
          }
          // Layer 2
          for (let i = 0; i < this.nbRows; i += 2) {
            for (let j = incrementFactor / 2; j < this.nbCols; j += incrementFactor) {
              this.autoPoints[i].rowArray[j].layer = 1;
            }
          }
          break;
        }
        case "algo2": {
          // layer 1
          let startIdx1 = 0; // startIdx0;
          for (let i = 1; i < this.nbRows; i += 2) {
            for (let j = startIdx1; j < this.nbCols; j += incrementFactor) {
              this.autoPoints[i].rowArray[j].layer = 0;
            }
            startIdx1 = (startIdx1 + incrementFactor / 2) % incrementFactor;
          }
          // layer 2
          let startIdx2 = incrementFactor / 2;
          for (let i = 0; i < this.nbRows; i += 2) {
            for (let j = startIdx2; j < this.nbCols; j += incrementFactor) {
              this.autoPoints[i].rowArray[j].layer = 1;
            }
            startIdx2 = (startIdx2 + incrementFactor / 2) % incrementFactor;
          }
          break;
        }
      }
      return;
    },
    ///////////////////////////////////////////////////////////////
    setMlp: function() {
      this.mlpRow = this.startRow;
      if (this.seats[0] % 2 === 0 && this.seats.length > 1 && this.seats[1] % 2 !== 0) {
        this.mlpRow += 2;
      }
      this.mlpCol = Math.floor(this.nbCols / 2);
      while ((this.autoPoints[this.mlpRow].rowArray[this.mlpCol].layer !== 0) && (this.mlpCol < this.nbCols)) {
        this.mlpCol += 1; // guarantee the MLP falls on an existing measurement in layer 1
      }
      return;
    },
    ///////////////////////////////////////////////////////////////
    setMeasurementBoundaries: function() {
      if (!this.allowDisplayMatrice) return
      
      this.autoPoints[0].rowArray.forEach((square) => {
        square.measurementBoundary.push("top");
      });
      this.autoPoints[this.nbRows - 1].rowArray.forEach((square) => {
        square.measurementBoundary.push("bottom");
      });
      for (let i = 0; i < this.nbRows; i++) {
        this.autoPoints[i].rowArray[0].measurementBoundary.push("left");
        this.autoPoints[i].rowArray[this.nbCols - 1].measurementBoundary.push("right");
      }
      return;
    },
    ///////////////////////////////////////////////////////////////
    addRoomBoundaries: function(points) {
      let room = points;

      // insert left and right walls for each row 
      for (let i = 0; i < points.length; i++) {
        room[i].rowArray.unshift({ 
            id: -1,
            row: -1,
            col: -1,
            layer: -1, 
            seat: false,
            measurementBoundary: [],
            roomBoundary: ["left"]
          });
          room[i].rowArray.push({ 
            id: -1,
            row: -1,
            col: -1,
            layer: -1, 
            seat: false,
            measurementBoundary: [],
            roomBoundary: ["right"]
          });
      }
      // insert top (front) wall
      let frontWall = [];
      for (let j = 0; j < room[0].rowArray.length; j++) {
        frontWall.push({ 
          id: -1,
          row: -1,
          col: -1,
          layer: -1, 
          seat: false,
          measurementBoundary: [],
          roomBoundary: ["top"]
        });
      }

      frontWall[0].roomBoundary.push("left");
      frontWall[room[0].rowArray.length - 1].roomBoundary.push("right");
      room.unshift({
        rowArray: frontWall,
        containSeats: false,
        listeningStart: -1,
        listeningEnd: -1
      });
      // insert rear (bottom) wall
      let rearWall = [];
      for (let j = 0; j < room[0].rowArray.length; j++) {
        rearWall.push({ 
          id: -1,
          row: -1,
          col: -1,
          layer: -1, 
          seat: false,
          measurementBoundary: [],
          roomBoundary: ["bottom"]
        });
      }
      rearWall[0].roomBoundary.push("left");
      rearWall[room[0].rowArray.length - 1].roomBoundary.push("right");
      room.push({
        rowArray: rearWall,
        listeningEnd: -1
      });
      return room;
    },
    ///////////////////////////////////////////////////////////////
    calculateNbPoints(matrice) {
      let nbPoints = 0;

      for (let i = 0; i < matrice.length; i++) {
        for (let j = 0; j < matrice[i].rowArray.length; j++) {
          if (matrice[i].rowArray[j].layer !== -1) // MAX faut mettre > 0 au cas où -2 -3 sont utitlisés pour autres choses ??
            nbPoints++;
        }
      }

      this.$emit("NbPointsChanged", nbPoints);
      return nbPoints
    },
    ///////////////////////////////////////////////////////////////
    isLayoutSymmetric: function(nbCols, skipFactor) {
      if ((nbCols - 1) % (skipFactor + 1) === 0) {
        return true
      }
      else {
        return false
      }      
    },
    ///////////////////////////////////////////////////////////////
    reduceNbPoints: function() {
      //
      if (this.isIncreasedNbCols) {
        this.removeSideCols();
        this.initMatrice();
        this.setSeats();
        this.setMeasurements();
        this.nbPoints = this.calculateNbPoints(this.autoPoints);
        if (this.nbPoints <= this.maxNbPoints) 
          return;
      }
      //
      this.skipFactor = 1;
      let counter = 0;

      while (this.nbPoints > this.maxNbPoints) {
        counter++;

        if (counter > 5) {
          console.warn("While loop exceeded ", counter, " iterations.");
          break;
        }

        this.counter = counter;

        if (this.seats.length >= 3 && !this.isReducedNbRows) {
          this.deleteFirstRow();
          this.nbPoints = this.calculateNbPoints(this.autoPoints);
          if (this.nbPoints <= this.maxNbPoints) 
            break;
        }

        let mustReduceDensity = true;
        while (mustReduceDensity && this.skipFactor < this.nbCols - 2) {
          this.skipFactor += 2;
          this.setMatrixSize();
          this.insertSideCols(); // try first with side columns for skipFactor >= 3
          if (this.isLayoutSymmetric(this.nbCols, this.skipFactor))
            mustReduceDensity = false;
          else if (this.isLayoutSymmetric(this.nbCols - 2, this.skipFactor)) {
            this.removeSideCols();
            mustReduceDensity = false;
          }
        }

        if (this.skipFactor >= this.nbCols - 2) {
          this.allowDisplayMatrice = false;
          // console.error("MAXIME maxNbPoints trop petit");
          return;
        }

        this.initMatrice();
        this.setSeats();
        this.setMeasurements();
        this.nbPoints = this.calculateNbPoints(this.autoPoints);
      }
      this.allowDisplayMatrice = true;
      return;
    },
    ///////////////////////////////////////////////////////////////
    labelMeasures: function() {
      let measureLayer1ID = 1;

      for (let i = 0; i < this.room.length; i++) {
        for (let j = 0; j < this.room[i].rowArray.length; j++) {
          if (this.room[i].rowArray[j].layer === 0) {
            this.room[i].rowArray[j]["label"] = measureLayer1ID;
            measureLayer1ID++;
          }
        }
      }

      for (let i = 0; i < this.room.length; i++) {
        for (let j = 0; j < this.room[i].rowArray.length; j++) {
          if (this.room[i].rowArray[j].layer === 1) {
            this.room[i].rowArray[j]["label"] = measureLayer1ID;
            measureLayer1ID++;
          }
        }
      }
      return;
    },
    ///////////////////////////////////////////////////////////////
    exportMatrixAsJpeg() {
      const svgMatrix = document.getElementById('svgMatrix');
      const rows = svgMatrix.getElementsByClassName('row-svg');
      const cellWidth = this.renderSquareSize;
      const cellHeight = this.renderSquareSize;
      const scaleFactor = 8;  // Factor to increase the resolution

      // Déterminer la taille du canvas en fonction de la matrice
      const canvas = document.createElement('canvas');
      canvas.width = this.renderMatriceCombinated[0].rowArray.length * cellWidth * scaleFactor;
      canvas.height = this.renderMatriceCombinated.length * cellHeight * scaleFactor;
      const context = canvas.getContext('2d');
      context.scale(scaleFactor, scaleFactor);

      context.fillStyle = 'rgb(42, 48, 56)';
      context.fillRect(0, 0, canvas.width / scaleFactor, canvas.height / scaleFactor);

      const promises = [];

      Array.from(rows).forEach((row, rowIndex) => {
        const cells = row.getElementsByClassName('cell-svg');
        Array.from(cells).forEach((cell, cellIndex) => {
          const svgContainer = cell.querySelector('.svg-container');
          const svg = svgContainer.querySelector('svg');
          const serializer = new XMLSerializer();
          const source = serializer.serializeToString(svg);
          const svgBlob = new Blob([source], { type: 'image/svg+xml;charset=utf-8' });
          const url = URL.createObjectURL(svgBlob);
          const img = new Image();

          promises.push(new Promise((resolve) => {
            img.onload = () => {
              context.drawImage(img, cellIndex * cellWidth, rowIndex * cellHeight, cellWidth, cellHeight);
              URL.revokeObjectURL(url);
              resolve();
            };
            img.src = url;
          }));
        });
      });

      Promise.all(promises).then(() => {
        const jpegUrl = canvas.toDataURL('image/jpeg', 1.0);  // Use 1.0 for best quality
        const downloadLink = document.createElement('a');
        downloadLink.href = jpegUrl;
        let title = "Waveforming measurement layout (seats(";
        for (let i = 0; i < this.seats.length; i++) {
          title += this.seats[i];
          if (i < this.seats.length - 1)
            title += ", ";
        }
        title += "), " + this.nbPoints + " points)";
        downloadLink.download = title + '.jpeg';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      });
    }
  },
  ///////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////
  computed: {
    renderSquareSize: function() {
      if (!this.autoPoints || this.autoPoints.length === 0) return;

      const squareWidth = Math.min(this.matriceMaxWidth / (this.nbCols + 2), this.matriceMaxHeight / (this.nbRows + 2));
      return squareWidth;
    },
    ///////////////////////////////////////////////////////////////
    renderMatriceCombinated: function() {
      if (!this.autoPoints || this.autoPoints.length === 0) return;
      if (!this.userPoints) return;

      let points = _.cloneDeep(this.autoPoints);

      if (this.userPoints.length > 0) {
        for (let i = 0; i < this.userPoints.length; i++) {
          points[this.userPoints[i].row + 1].rowArray[this.userPoints[i].col + 1].layer = this.userPoints[i].layer;
        }
      }

      this.calculateNbPoints(points);

      return points;
    },
    ///////////////////////////////////////////////////////////////
    renderContextualHelpTitle: function() {
      if (!this.contextualHelp) return;

      return this.$t("measureHelpTitle_" + this.contextualHelp);
    },
    ///////////////////////////////////////////////////////////////
    renderContextualHelp: function() {
      if (!this.contextualHelp) return;

      return this.$t("measureHelp_" + this.contextualHelp);
    },
    ///////////////////////////////////////////////////////////////
    renderMidCol: function() {
      if (!this.renderMatriceCombinated || this.renderMatriceCombinated.length ===0) return;

      return (this.renderMatriceCombinated[0].rowArray.length - 1 )/ 2;
    }
  },
  ///////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////
  watch: {
    seats: {
      handler() {
        this.renderMatrice();
      },
      deep: true,
    },
    ///////////////////////////////////////////////////////////////
    algoSelected: function(newVal, oldVal) {
      if (oldVal !== newVal) {
        if (newVal !== "custom") {
          this.userPoints = [];
          this.mlpUser = false;
          this.renderMatrice();
        }
      }
    },
    ///////////////////////////////////////////////////////////////
    maxNbPoints: function() {
      this.renderMatrice();
    },
    ///////////////////////////////////////////////////////////////
    doExport: function(newVal, oldVal) {
      if (newVal !== oldVal)
        this.exportMatrixAsJpeg();
    },
    ///////////////////////////////////////////////////////////////
    allowDisplayMatrice: function(newVal, oldVal) {
      if (newVal !== oldVal)
        this.$emit("AllowExport", newVal);
    }
  }
}
</script>


<style>
.tip-help {
  font-size: 2vh;
}

#error_help {
  width: 90%;
  margin-left: 5%;
  height: 24vh;
}
</style>